export default {
  ROLE: 100,
  IDENTITY: 200,
}